module.exports = __webpack_public_path__ + "static/img/ability04.b3680067.webp";